import {IconCloudDownload} from '@tabler/icons-react';
import {Button} from 'src/design/atoms/Button';
import type {ButtonProps} from 'src/design/atoms/Button';

/**
 * "Export" button — thin `Button` wrapper with a cloud-download icon,
 * `variant="subtle"`, `color="gray"`, `size="md"`, defaulting its label to
 * "Export".
 * @registry Secondary "export data" action button.
 *
 * Ported from `library-m/components/buttons/ExportButton`. Prop surface
 * kept identical (all `Button` props pass through, `children` defaults to
 * "Export" but can still be overridden).
 */
export type ExportButtonProps = ButtonProps;

export const ExportButton = ({
  variant = 'subtle',
  color = 'gray',
  leftSection = <IconCloudDownload />,
  size = 'md',
  children = 'Export',
  ...props
}: ExportButtonProps) => (
  <Button
    variant={variant}
    color={color}
    leftSection={leftSection}
    size={size}
    {...props}>
    {children}
  </Button>
);
